import { render } from "./VideoCard.vue?vue&type=template&id=669d4942"
import script from "./VideoCard.vue?vue&type=script&lang=js"
export * from "./VideoCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/runcloud1user/webapps/ismail-khayat-vue/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__